import { useContext } from "react";

import { UserContext } from "../components/user/UserProvider";

const useUser = () => useContext(UserContext);

export default useUser;
